import React, { Component } from "react";
import styled from "styled-components";
import { history } from "../../utils";
// import Gamification from '../Gamification';
import { Flex, Link, Button } from "../../components";
// import amplitude from 'amplitude-js/aplitude';
// // import Amplitude from 'react-amplitude';
// import moment from 'moment';
import { track } from '@amplitude/analytics-browser';


// amplitude.getInstance().init('b781fe374c11394b27e21b826356483c');

const TestDescriptionWrapper = styled.div`
  display: grid;
  grid-gap: 2rem;
  margin-bottom: 6rem;
  img {
    width: 100%;
  }
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;

function checkNative() {
  try {
    if ((window.webkit) || window.appInterface)
      return true;
    else return false;
  } catch (error) {
    console.log(error);
  }
}


// function logAmplitudeEvent(results) {
//   if (!results) {
//     let time_stamp = moment().format('YYYY-MM-DD hh:mm:ss').toString();
//     // Amplitude.logEventWithTimestamp('test started', null, time_stamp, null);
//     amplitude.getInstance().logEvent('started test 2016')
//   }
// }


class TestDescription extends Component {


  state = {
    // showGamificaton: false,
    numbers: [1, 2, 3],
    currentNumber: 1,
    tid: null,
    results: null
  }


  componentDidMount(){
    let { tid, name, test_img, timelimit, expiryTime, description, results, sections, message, resume_test, remaining_test_duration } = this.props
    const eventProperties = {
      test_id: tid,
      test_name : name,
      timelimit,
      expiryTime,
      results,
      resume_test,
      remaining_test_duration,
      // previois_screen_name: 'dashboard'
      }
      if (results) {
        track('test_results_description',eventProperties);
      }
      else{
        track('test_description',eventProperties);
      }
  }
  
  startTest = (tid, results, search) => {
    if(this.state.reattempt_msg && this.state.tid){
      // // this.setState({ showGamificaton: true });
      // setTimeout(() => {
      //   // this.setState({ showGamificaton: false });
      //   if (this.state.results) 
      //     history.push(`/testResults/${this.state.tid}/0`);
      //   else 
      //     history.push(`/test/${this.state.tid}/0`);
      // }, 4200);

    let { name, timelimit, expiryTime,results, resume_test, remaining_test_duration } = this.props
    const eventProperties = {
      test_id: this.state.tid,
      test_name : name,
      timelimit,
      expiryTime,
      results,
      resume_test,
      remaining_test_duration,
      // previois_screen_name: 'dashboard'
      }

    if (this.state.results){ 
      track('test_results',eventProperties);
      history.push(`/testResults/${this.state.tid}/0`);
    }
    else {
      track('test_started',eventProperties);
      history.push(`/test/${this.state.tid}/0`)
    }
    }
    else this.setState({reattempt_msg: true, tid: tid, results: results});
  }

  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
        // console(`webkit : ${msg}`);
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg);
        // console(`appInterface : ${msg}`);

      }
    } catch (error) {
      console.log(msg);
      console(error);
    }
  }

  render() {
    let { tid, name, test_img, timelimit, expiryTime, description, results, sections, message, resume_test, remaining_test_duration } = this.props
    // if (this.state.showGamificaton) {
    //   return <Gamification></Gamification>
    // }
    return (
      <div style={{ padding: '20px' }}>
        <Flex column center>

          {name ?
            <div>
              <div style={{ position: 'fixed', top: '0', paddingTop: '20px', left: '20px', background: '#f6f6f6', width: '100%', cursor: 'pointer' }}>
                {/* <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img> */}
                {/* Sending an empty string in callbacktoNative will just take us out of the test from iOS and Android app without raising a submission request */}
                <img onClick={() => this.callbackToNative('')} src="/images/back.svg"></img>
              </div>
              <h1 style={{ margin: '0.3em 0', fontSize: '28px', textAlign: 'center', marginTop: '30px' }}>{name}</h1>
              <TestDescriptionWrapper>
                {/* {test_img &&
            <img
              src={test_img}
              alt=""
            />
          } */}
                <Flex column>
                  <h3 style={{ fontSize: '20px', margin: '0.3em 0' }}>Description</h3>
                  <p>{description}</p>
                  <h3 style={{ fontSize: '20px', margin: '0.3em 0' }}>Duration of the test</h3>
                  <p>{expiryTime < timelimit ? (parseFloat(expiryTime).toFixed() / 60).toFixed() : parseFloat(timelimit).toFixed() / 60} minutes</p>
                  <div>
                    <h3 style={{ fontSize: '20px', margin: '0.3em 0' }}>Instructions:</h3>
                    <ul>
                      {sections.length != 0 ? <li>
                        <b>There are {sections.length} sections in this test.</b>
                        <ul style={{ paddingLeft: '20px', }}>
                          {sections.map((sec, index) => {
                            return <li key={index}>
                              <div style={{ fontWeight: 'bold' }}> Section {index + 1} :</div>

                              <div style={{ fontStyle: 'italic' }}>Name: {sec.name}</div>
                              <div style={{ fontStyle: 'italic' }}>Marks: {sec.marks}</div>
                              {sec.instructions && <div>Instructions: {sec.instructions}</div>}
                            </li>
                          })}
                        </ul>
                      </li> : null}
                      <li>
                        <b>Make sure that you don’t switch the app. Switching more than twice submits the test.</b>
                      </li>
                      <li>
                        <b>Please put your phone in Do-Not-Disturb (DND) mode while taking the test.</b>
                      </li>
                      <li>
                        Total Duration of test is allocated by the faculty and is shown on the top of the test screen.
                </li>
                      <li>
                        The Test should be taken within the time of expiry as mentioned by the faculty.
                </li>
                      <li>
                        The test will be Multiple choice questions with a single correct answer.
                </li>
                      <li>
                        There is no negative marking for the incorrectly answered questions.
                </li>
                      <li>
                        One point will be awarded for each correctly answered question.
                </li>
                      <li>
                        The Test will be auto-submitted once the allocated duration of the test completes.
                </li>
                      <li>
                        There will be four level of questions: Remembering, Understanding, Applying and Analyzing.
                </li>
                      <li>
                        The results for the test will auto-appear once the test gets expired.
                </li>
                      <li>
                        The detailed report for the test and correct answers will be shown in the results.
                </li>
                      <li>WARNING:  You are not allowed to take any screenshots during the test, this may effect your scores. </li>
                      <li>
                        The scores generated in the test will have a huge impact on your performance analytics.
                </li>
                    </ul>
                  </div>
                </Flex>
              </TestDescriptionWrapper>

              <div style={{ backgroundColor: '#f6f6f6', position: 'fixed', bottom: '0', background: '#f6f6f6', overflowY: 'hidden', width: '100%', margin: '0 auto' }}>
                <Flex direction="row" justifyBetween alignCenter style={{ padding: '0 20%', paddingBottom: '10px' }}>
                  {/* <Link to={results ? `/testResults/${tid}/0` : `/test/${tid}/0`}> */}
                  {/* <button onClick={(results)=>logAmplitudeEvent(results)} className='startButton'>{results ? `Show answers` : `START TEST`}</button> */}
                  <div>
                    <button className='startButton' onClick={() => this.startTest(tid, results)} >{results ? `Show answers` : `START TEST`}</button>
                  </div>
                  {/* </Link> */}
                  {/* <Button small onClick={() => callbackToNative('done')} background="white" color="gray">Close </Button> */}
                </Flex>
              </div>
            </div>
            : null
          }

        </Flex>
        <div className="modal" style={{ display: this.state.reattempt_msg ? 'block' : 'none' }} >
          <div className="modal-content">
            <div>
              <p className="text-danger" style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>MUST READ</p>
              <p className="text-left">1. The test once opened either on your mobile or web application, will need <b>to be continued on the same device</b>, else you will be aborted from the test.</p>
              <p className="text-left">2. Once the test is started, you will <b>NOT</b> be allowed to change the device, attempt the test from other device or reattempt from same device.</p>
              <div onClick={() => this.startTest()} style={{ color: "#6568d9", textAlign: 'center', fontWeight: 'bold' }}>
                I Confirm
              </div>
            </div>
          </div>
        </div>
        <style jsx="true" scoped='true'>{`
          .modal {
            // position: fixed; /* Stay in place */
            // z-index: 5; /* Sit on top */
            // left: 0;
            // top: 0;
            // width: 100%; /* Full width */
            // height: 100%; /* Full height */
            // overflow: auto; /* Enable scroll if needed */
            // background-color: rgb(0,0,0); /* Fallback color */
            // background-color: rgba(0,0,0,0.4); /* Black w/ opacity */

            --tw-bg-opacity: 1;
            background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
            --tw-bg-opacity: 0.5;
            height: 100%;
            position: fixed;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            width: 100%;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          /* Modal Content */
          .modal-content {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            margin: auto;
            margin-top: 'auto';
            width: 80%;
            padding: 30px;
            background: #ffffff;
            box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.199437);
            border-radius: 8px;
            box-sizing: border-box;
            height: 'auto';
            overflow: auto;
          }
          
          /* The Close Button */
          .close {
            color: #aaaaaa;
            float: right;
            font-size: 28px;
            font-weight: bold;
          }
          
          .close:hover,
          .close:focus {
            color: #000;
            text-decoration: none;
            cursor: pointer;
          }
          .startButton{
              padding: 0.5em 2.5em;
              font-size: 16px;
              font-weight: bold;
              border-radius: 16px;
              background: 
                linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
                linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
              color: white;
              border: none;
              cursor: pointer;
              &:focus{
                outline:0;
              }
          }      
        `}
        </style>
      </div>

    )
  }
}

export default TestDescription;
